import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/ElegantMilestone.css';

const ElegantMilestone = ({ isPreview = true }) => {
  const { celebrantName } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse celebrant name
  const formatName = (name) => {
    if (!name) return 'Celebrant';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const invitationData = {
    celebrantName: formatName(celebrantName),
    age: '50',
    milestone: 'Golden',
    partyDate: 'July 20, 2026',
    partyDay: 'Saturday',
    partyTime: '6:00 PM',
    venue: 'The Peninsula Manila',
    venueAddress: 'Ayala Avenue, Makati City',
    message: 'You are cordially invited to celebrate this momentous milestone.',
    dressCode: 'Formal / Cocktail Attire',
    colors: 'Gold & Black'
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="elegant-milestone">
      {/* Elegant Elements */}
      <div className="elegant-elements">
        <div className="sparkle sparkle-1">✦</div>
        <div className="sparkle sparkle-2">✧</div>
        <div className="sparkle sparkle-3">✦</div>
        <div className="sparkle sparkle-4">✧</div>
        <div className="sparkle sparkle-5">✦</div>
      </div>

      {/* Main Content */}
      <div className={`milestone-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="milestone-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="milestone-section home-section">
            <div className="milestone-frame">
              <div className="golden-border">
                <div className="corner-accent top-left"></div>
                <div className="corner-accent top-right"></div>
                <div className="corner-accent bottom-left"></div>
                <div className="corner-accent bottom-right"></div>
                
                <div className="home-content">
                  <p className="celebration-prefix">You Are Invited to</p>
                  
                  <div className="celebrant-info">
                    <span className="celebrant-name">{invitationData.celebrantName}'s</span>
                    <span className="milestone-text">{invitationData.milestone} Celebration</span>
                  </div>

                  <div className="age-display">
                    <span className="age-number">{invitationData.age}</span>
                    <span className="years-text">Years</span>
                  </div>

                  <div className="elegant-divider">
                    <span className="divider-line"></span>
                    <span className="divider-ornament">❖</span>
                    <span className="divider-line"></span>
                  </div>

                  <p className="invitation-text">{invitationData.message}</p>

                  <div className="event-date-display">
                    <div className="date-elegant">
                      <span className="day-name">{invitationData.partyDay}</span>
                      <span className="date-line"></span>
                      <span className="full-date">{invitationData.partyDate}</span>
                      <span className="time">{invitationData.partyTime}</span>
                    </div>
                  </div>

                  <button 
                    className="view-details-btn"
                    onClick={() => setActiveSection('details')}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="milestone-section details-section">
            <h2 className="section-title">
              <span className="title-ornament">❖</span>
              Event Details
              <span className="title-ornament">❖</span>
            </h2>

            <div className="details-grid">
              <div className="detail-card">
                <div className="detail-icon">📍</div>
                <h3>Venue</h3>
                <p className="venue-name">{invitationData.venue}</p>
                <p className="venue-address">{invitationData.venueAddress}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🕕</div>
                <h3>Schedule</h3>
                <p className="schedule-date">{invitationData.partyDate}</p>
                <p className="schedule-time">{invitationData.partyTime}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">👔</div>
                <h3>Dress Code</h3>
                <p className="dress-info">{invitationData.dressCode}</p>
                <p className="color-info">Colors: {invitationData.colors}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🎁</div>
                <h3>Gift Guide</h3>
                <p className="gift-message">Your presence is the greatest gift.</p>
                <p className="gift-note">No boxed gifts, please.</p>
              </div>
            </div>

            <div className="countdown-section">
              <h3>Counting Down to the Celebration</h3>
              <div className="countdown-display">
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Days</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Hours</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Mins</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Secs</span>
                </div>
              </div>
            </div>

            <button 
              className="rsvp-cta-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              RSVP Now
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="milestone-section rsvp-section">
            <h2 className="section-title">
              <span className="title-ornament">❖</span>
              RSVP
              <span className="title-ornament">❖</span>
            </h2>

            <form className="milestone-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">We would be honored by your presence</p>
              <p className="rsvp-deadline">Kindly respond by July 5, 2026</p>

              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Enter your name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Will you be attending?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✓</span>
                    <span className="option-text">Graciously Accepts</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✗</span>
                    <span className="option-text">Respectfully Declines</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Number of Guests</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Share your warm wishes..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="submit-rsvp-btn" disabled={isPreview}>
                Send RSVP
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="milestone-watermark">
          <a href="/invitations" className="back-to-templates-btn">Back to Designs</a>
          <p>Created with ♥ by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default ElegantMilestone;
